export const types = {
  GET_PARQUE_CODE: 'PRODUCTS/GET_PARQUE_CODE',
};

const initialState = { }

const Legado = (state = initialState, action) => {
  switch (action.type) {
    case
      types.GET_PARQUE_CODE:
    default:
      return { ...state }
  }
};

export const actions = {
  launchIframeCCLIListener: params => ({
    type: types.GET_PARQUE_CODE,
    params,
  }),
};

export default Legado;
